let VUEUpLoad = {}

VUEUpLoad.QUEUE_ERROR = {
  QUEUE_LIMIT_EXCEEDED: -100,
  FILE_EXCEEDS_SIZE_LIMIT: -110,
  ZERO_BYTE_FILE: -120,
  INVALID_FILETYPE: -130,
  DROP_DIRECTORY: -140
}

VUEUpLoad.UPLOAD_ERROR = {
  HTTP_ERROR: -200,
  MISSING_UPLOAD_URL: -210,
  IO_ERROR: -220,
  SECURITY_ERROR: -230,
  UPLOAD_LIMIT_EXCEEDED: -240,
  UPLOAD_FAILED: -250,
  SPECIFIED_FILE_ID_NOT_FOUND: -260,
  FILE_VALIDATION_FAILED: -270,
  FILE_CANCELLED: -280,
  UPLOAD_STOPPED: -290
}

VUEUpLoad.FILE_STATUS = {
  QUEUED: -1,
  IN_PROGRESS: -2,
  ERROR: -3,
  COMPLETE: -4,
  CANCELLED: -5
}

export default VUEUpLoad



// WEBPACK FOOTER //
// ./src/components/upload/upload_vue/upload-config.js